import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ShopDrivingRangeOptionSetting } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopDrivingRangeOptionSetting';

import { callShopDrivingRangeOptionSetting, callEditShopDrivingRangeOptionSetting } from 'network/apis/shop/shopDrivingRangeOptionSetting';

// 매장 연습장 옵션 정보 조회 사가 함수
function* loadShopDrivingRangeOptionSettingRequestSaga() {
    try {
        const manager = yield select(state => state.manager);

        const response = yield call(callShopDrivingRangeOptionSetting, manager.manager.shopGuid);

        yield put(actions.loadShopDrivingRangeOptionSettingRequestSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopDrivingRangeOptionSettingRequestFailure(error.message));
    }
}

// 매장 연습장 옵션 정보 조회 사가 함수
function* editShopDrivingRangeOptionSettingRequestSaga() {
    try {
        const manager = yield select(state => state.manager);
        const shopDrivingRangeOptionSetting = yield select(state => state.shopDrivingRangeOptionSetting);

        const data ={
            courseId: shopDrivingRangeOptionSetting.data.courseId,
            difficulty: shopDrivingRangeOptionSetting.data.difficulty,
            teeHeight: shopDrivingRangeOptionSetting.data.teeHeight,
            windSpeed: shopDrivingRangeOptionSetting.data.windSpeed,
            distanceUnit: shopDrivingRangeOptionSetting.data.distanceUnit,
            useSwingPlate: shopDrivingRangeOptionSetting.data.useSwingPlate,
            isBallTrajectory: shopDrivingRangeOptionSetting.data.isBallTrajectory,
            isFixedCamera: shopDrivingRangeOptionSetting.data.isFixedCamera,
            isSwingVideo: shopDrivingRangeOptionSetting.data.isSwingVideo
        };

        const response = yield call(callEditShopDrivingRangeOptionSetting, manager.manager.shopGuid, data);

        yield put(actions.editShopDrivingRangeOptionSettingRequestSuccess(response.data));

        alert('연습장 옵션 수정이 완료되었습니다.');

    } catch(error) {
        yield put(actions.editShopDrivingRangeOptionSettingRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ShopDrivingRangeOptionSetting.LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST, loadShopDrivingRangeOptionSettingRequestSaga),
        takeLatest(ShopDrivingRangeOptionSetting.EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST, editShopDrivingRangeOptionSettingRequestSaga),
    ]);
}